// extracted by mini-css-extract-plugin
export default {"hwaFooter":"HWAFooter_hwaFooter__Y+c5a","horzList":"HWAFooter_horzList__Qln9O"};